import { render } from "./dispatchMessage.vue?vue&type=template&id=4c86812e&scoped=true"
import script from "./dispatchMessage.vue?vue&type=script&lang=js"
export * from "./dispatchMessage.vue?vue&type=script&lang=js"

import "./dispatchMessage.vue?vue&type=style&index=0&id=4c86812e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c86812e"]])

export default __exports__